import { Stack, Box, IconButton } from "@mui/material"
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import UpIcon from '@mui/icons-material/KeyboardArrowUp';
import LockIcon from '@mui/icons-material/Lock';
import moment from "moment";
import Check from "./Check";
import Section from "./Section";
import Collapse from '@mui/material/Collapse';
import useCourse from "../Hooks/useCourse";

export default function Chapter({chapter, open, onToggle}){

    const course = useCourse();

    const completed = chapter.sections.filter(s => s.completed).length === chapter.sections.length;

    /** Chapter announced but not released yet for the session of the learner */
    const locked = chapter.unlockAt && moment(chapter.unlockAt).valueOf() > moment().valueOf();

    return <>

        <article className='study-chapter' data-id={chapter.id} onClick={onToggle}>

            <Stack direction='row' alignItems='center' spacing={1}>

                {locked 
                    ? <LockIcon sx={{width: 20, color: 'text.disabled'}} /> 
                    : <Check value={completed}/>
                }
            
                <Box sx={locked ? {color: 'text.disabled'} : null}>

                    {chapter.title}

                    {locked &&
                        <Box sx={{fontSize: '0.75rem'}}>
                            Disponible le {moment(chapter.unlockAt).format('DD/MM/YYYY')}
                        </Box>
                    }

                </Box>

            </Stack>
            
            <IconButton size='small' sx={{ml: '2px'}}>

                {open ? <UpIcon /> : <DownIcon />}

            </IconButton>
            
        </article>


        <Collapse in={open}>

            {chapter.sections.map(s => 
                <Section 
                    section={s}
                    course={course}
                    key={s.id}
                />
            )}
        
        </Collapse>

    </>
}